import { Relation } from '../../model/data-model/data-model-base-objects';

SelectionGridFactory.$inject = ['mx.SolutionBuilderAgent.ObjectsGrid'];
export default function SelectionGridFactory(ObjectsGrid) {
	class SelectionGrid extends ObjectsGrid {
		constructor(props) {
			super(props);
		}

		initProperties() {
			super.initProperties();
			let relation;
			let onDblClick = angular.noop;
			let onClick = angular.noop;

			Object.defineProperties(this, {
				relation: {
					configurable: true,
					set: function (value) {
						if (value instanceof Relation) {
							relation = value;
							this.entityClassName = this.relation.relationsConfig.referenceTo;
						}
					},
					get: function () {
						return relation;
					},
				},
				invertRelation: {
					configurable: true,
					writable: true,
					value: false,
				},
				archived: {
					configurable: true,
					writable: true,
					value: false,
				},
				objectIDs: {
					configurable: true,
					writable: true,
				},
				useObjectId: {
					configurable: true,
					writable: true,
				},
				excludedIDs: {
					configurable: true,
					writable: true,
				},
				correctEntityFilter: {
					configurable: true,
					writable: true,
				},
				presetFields: {
					configurable: true,
					writable: true,
					value: {},
				},
				onClick: {
					configurable: true,
					set: function (handler) {
						if (typeof handler === 'function') {
							onClick = handler;
						}
					},
					get: function () {
						return onClick;
					},
				},
				onDblClick: {
					configurable: true,
					set: function (handler) {
						if (typeof handler === 'function') {
							onDblClick = handler;
						}
					},
					get: function () {
						return onDblClick;
					},
				},
			});
		}

		itemClickHandler(row) {
			this.onClick(row);
		}

		itemDblClickHandler(row) {
			this.onDblClick(row);
		}

		async onCreateButtonClick(item) {
			try {
				const createdRow = await this.createNewItem(item._type, item._itemType);
				const selectedRows = this.executor.allSelectedRows.concat([createdRow]);
				this.executor.changeSelection(selectedRows);
			} catch (e) {
				mx.logCatch(e);
			}
		}

		afterEntitiesCreated(/*newEntity*/) {}

		getCorrectEntityFilter() {
			return this.correctEntityFilter;
		}

		getPresetFields() {
			return this.presetFields;
		}

		updateRequest() {
			super.updateRequest();
			if (!this.executor) {
				return;
			}

			const options = {
				archived: this.archived,
				useObjectId: this.useObjectId,
			};

			if (this.relation) {
				if (this.invertRelation) {
					Object.assign(options, {
						entityClassName: this.relation.relationsConfig.referenceTo,
						fragmentId: this.relation.fragmentId,
						lookupFor: `${this.relation.relationsConfig.referenceFrom}.${this.relation.relationsConfig.attributeFrom}`,
					});
				} else {
					Object.assign(options, {
						entityClassName: this.relation.relationsConfig.referenceFrom,
						relationName: this.relation.relationsConfig.attributeFrom,
						fragmentId: this.relation.fragmentId,
					});
				}
			}

			this.executor.updateRequestOptions(options);
		}
	}

	return SelectionGrid;
}
